var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./styles.scss";
import * as PrimitiveDialog from "@react-components/primitives/Dialog/Dialog";
import { CrossIcon } from "@react-components/primitives/Icons/Icons";
import { replaceUrlSearchParams } from "@common/replace-url-search-params";
import { generateColumns, } from "@react-common/helpers/generate-columns";
export var SELECTED_URL_SEARCH_PARAM = "dialog";
var handleUrlSearchParamsOnOpenChange = function (isOpen, id) {
    if (!id)
        return;
    var urlSearchParams = new URLSearchParams(window.location.search);
    if (isOpen) {
        urlSearchParams.set(SELECTED_URL_SEARCH_PARAM, id);
        console.log(urlSearchParams);
        replaceUrlSearchParams(urlSearchParams);
        return;
    }
    urlSearchParams.delete(SELECTED_URL_SEARCH_PARAM);
    replaceUrlSearchParams(urlSearchParams);
};
var Dialog = function (_a) {
    var onOpenChange = _a.onOpenChange, defaultOpen = _a.defaultOpen, id = _a.id, children = _a.children, otherProps = __rest(_a, ["onOpenChange", "defaultOpen", "id", "children"]);
    var urlSearchParams = new URLSearchParams(window.location.search);
    var searchParam = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(SELECTED_URL_SEARCH_PARAM);
    return (_jsx(PrimitiveDialog.DialogRoot, __assign({}, otherProps, { defaultOpen: defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : (searchParam === id ? true : undefined), onOpenChange: function (open) {
            onOpenChange && onOpenChange(open);
            handleUrlSearchParamsOnOpenChange(open, id);
        }, children: children })));
};
var Close = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(PrimitiveDialog.DialogClose, __assign({}, otherProps, { children: children })));
};
var Content = function (_a) {
    var _b;
    var columnSizes = _a.columnSizes, children = _a.children, otherProps = __rest(_a, ["columnSizes", "children"]);
    return (_jsx(PrimitiveDialog.DialogContent, __assign({ className: "dialog" }, otherProps, { children: _jsx("div", { className: "dialog__container container", children: _jsx("div", { className: "dialog__row row", children: _jsx("div", { className: "".concat((_b = generateColumns(columnSizes)) !== null && _b !== void 0 ? _b : "col-12 col-md-8"), children: _jsxs("div", { className: "dialog__content", children: [_jsx(Close, { className: "dialog__close", children: _jsx(CrossIcon, { size: 17 }) }), children] }) }) }) }) })));
};
var Overlay = function (_a) {
    var themeModifier = _a.themeModifier, otherProps = __rest(_a, ["themeModifier"]);
    return (_jsx(PrimitiveDialog.DialogOverlay, __assign({ className: "overlay ".concat(themeModifier ? themeModifier : "") }, otherProps)));
};
var Trigger = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(PrimitiveDialog.DialogTrigger, __assign({}, otherProps, { children: children })));
};
export { Dialog, Content, Overlay, Trigger, Close };
